import Vue from 'vue'
import Router from 'vue-router'

import Prototype from '../prototype'
import ForbiddenView from '../views/403View'
import LogonView from '../views/logon/LogonView'

import LenderHome from '../views/lender/LenderHome'
import ConfigView from '../views/lender/setting/Config'
import ConfigIndexView from '../views/lender/setting/ConfigIndex'

import ConfigSettingView from '../views/lender/setting/ConfigSetting'
import ConfigSettingFinancingView from '../views/lender/setting/ConfigSettingFinancing'

import ConfigUserView from '../views/lender/setting/ConfigUser'
import ConfigUserListView from '../views/lender/setting/ConfigUserList'
import ConfigUserEditView from '../views/lender/setting/ConfigUserEdit'
import ConfigUserAddView from '../views/lender/setting/ConfigUserEdit'
import ConfigUserDetailView from '../views/lender/setting/ConfigUserDetail'


import ConfigDepartmentView from '../views/lender/setting/ConfigDepartment'
import ConfigDepartmentListView from '../views/lender/setting/ConfigDepartmentList'
import ConfigDepartmentEditView from '../views/lender/setting/ConfigDepartmentEdit'

import ConfigRoleView from '../views/lender/setting/ConfigRole'
import ConfigRoleListView from '../views/lender/setting/ConfigRoleList'
import ConfigRoleEditView from '../views/lender/setting/ConfigRoleEdit'
import ConfigRoleFunctionEditView from '../views/lender/setting/ConfigRoleFunctionEdit'

import CustomerCustomerView from '../views/lender/CustomerAdmin/CustomerCustomer'
import CustomerCustomerListView from '../views/lender/CustomerAdmin/CustomerList'
import CustomerCustomerEditView from '../views/lender/CustomerAdmin/CustomerEdit'
import CustomerCustomerDetailView from '../views/lender/CustomerAdmin/CustomerDetail'

import CustomerDebtorView from '../views/lender/CustomerAdmin/Debtor'
import CustomerDebtorListView from '../views/lender/CustomerAdmin/DebtorList'
import CustomerDebtorEditView from '../views/lender/CustomerAdmin/DebtorEdit'

import CustomerDebtorUserView from '../views/lender/CustomerAdmin/DebtorUser'
import CustomerDebtorUserListView from '../views/lender/CustomerAdmin/DebtorUserList'
import CustomerDebtorUserEditView from '../views/lender/CustomerAdmin/DebtorUserEdit'


import CustomerUserView from '../views/lender/CustomerAdmin/CustomerUser'
import CustomerUserListView from '../views/lender/CustomerAdmin/CustomerUserList'
import CustomerUserEditView from '../views/lender/CustomerAdmin/CustomerUserEdit'

import CustomerApplyingCustomerView from '../views/lender/CustomerAdmin/CustomerApplying'
import CustomerApplyingCustomerListView from '../views/lender/CustomerAdmin/CustomerApplyingList'
import CustomerApplyingVehicleMortgageCustomerView from '../views/lender/CustomerAdmin/CustomerApplyingVehicleMortgage'
import CustomerApplyingVehicleMortgageCustomerListView from '../views/lender/CustomerAdmin/CustomerApplyingVehicleMortgageList'
import CustomerApplyingVehicleMortgageCustomerDetailView from '../views/lender/CustomerAdmin/CustomerApplyingVehicleMortgageDetail'
import CustomerApplyingVehicleMortgageCustomerApproveView from '../views/lender/CustomerAdmin/CustomerApplyingVehicleMortgageApprove'
import CustomerApplyingCustomerDetailView from '../views/lender/CustomerAdmin/CustomerApplyingDetail'
import CustomerApplyingCustomerApproveView from '../views/lender/CustomerAdmin/CustomerApplyingApprove'

import CustomerApplyingCustomerApproveZJLView from '../views/lender/CustomerAdmin/CustomerApplyingApproveZJL'
import CustomerApplyingCustomerApproveDSZView from '../views/lender/CustomerAdmin/CustomerApplyingApproveDSZ'
import CustomerApplyingCustomerApproveZSView from '../views/lender/CustomerAdmin/CustomerApplyingApproveZS'
import CustomerApplyingCustomerApproveKFView from '../views/lender/CustomerAdmin/CustomerApplyingApproveKF'

import CustomerApplyingCustomerBankAPView from '../views/lender/CustomerAdmin/CustomerApplyingBankAP'

import ServiceAdminBankAccountView from '../views/lender/ServiceAdmin/BankAccount'
import ServiceAdminBankAccountListView from '../views/lender/ServiceAdmin/BankAccountList'

import ServiceAdminProductView from '../views/lender/ServiceAdmin/Product'
import ServiceAdminProductListView from '../views/lender/ServiceAdmin/ProductList'
import ServiceAdminProductDetailView from '../views/lender/ServiceAdmin/ProductDetail'
import ServiceAdminProductEditView from '../views/lender/ServiceAdmin/ProductEdit'

import ServiceAdminCreditView from '../views/lender/ServiceAdmin/Credit'
import ServiceAdminCreditListView from '../views/lender/ServiceAdmin/CreditList'
import ServiceAdminCreditDetailView from '../views/lender/ServiceAdmin/CreditDetail'
import ServiceAdminCreditEditView from '../views/lender/ServiceAdmin/CreditEdit'

import ServiceAdminContractView from '../views/lender/ServiceAdmin/Contract'
import ServiceAdminContractApplyingListView from '../views/lender/ServiceAdmin/ContractApplyingList'
import ServiceAdminContractApplyingDetailView from '../views/lender/ServiceAdmin/ContractApplyingDetail'
import ServiceAdminContractListView from '../views/lender/ServiceAdmin/ContractList'
import ServiceAdminContractDetailView from '../views/lender/ServiceAdmin/ContractDetail'

import ServiceAdminPledgeView from '../views/lender/ServiceAdmin/Pledge'
import ServiceAdminPledgeApplyingListView from '../views/lender/ServiceAdmin/PledgeApplyingList'
import ServiceAdminPledgeApplyingDetailView from '../views/lender/ServiceAdmin/PledgeApplyingDetail'
import ServiceAdminPledgeListView from '../views/lender/ServiceAdmin/PledgeList'
import ServiceAdminPledgeDetailView from '../views/lender/ServiceAdmin/PledgeDetail'
import ServiceAdminPledgeInvoiceListView from '../views/lender/ServiceAdmin/InvoiceList'
import ServiceAdminPledgeInvoiceDetailView from '../views/lender/ServiceAdmin/InvoiceDetail'

import ServiceAdminFinancingView from '../views/lender/ServiceAdmin/Financing'
import ServiceAdminFinancingApplyingListView from '../views/lender/ServiceAdmin/FinancingApplyingList'
import ServiceAdminFinancingApplyingDetailView from '../views/lender/ServiceAdmin/FinancingApplyingDetail'
import ServiceAdminFinancingListView from '../views/lender/ServiceAdmin/FinancingList'
import ServiceAdminFinancingDetailView from '../views/lender/ServiceAdmin/FinancingDetail'
import ServiceAdminFinancingRepayView from '../views/lender/ServiceAdmin/FinancingRepay'
import ServiceAdminFinancingRepaymentListView from '../views/lender/ServiceAdmin/FinancingRepaymentList'
import ServiceAdminFinancingRepayDetailView from'../views/lender/ServiceAdmin/FinancingRepayDetail'
import ServiceAdminCustomerListView from'../views/lender/ServiceAdmin/CustomerList'
import ServiceAdminCashJournalListView from'../views/lender/ServiceAdmin/CashJournalList'

import FinanceIndex from '../views/lender/Finance/FinanceIndex'
import FinancePaymentView from '../views/lender/Finance/FinancePayment'
import FinancePaymentPendingPayListView from '../views/lender/Finance/FinancePaymentPendingPayList'
import FinancePaymentDetailView from '../views/lender/Finance/FinancePaymentDetail'
import FinanceRepaymentView from '../views/lender/Finance/FinanceRepayment'
import FinanceRepaymentListView from '../views/lender/Finance/FinanceRepaymentList'
import FinanceRepaymentDetailView from '../views/lender/Finance/FinanceRepaymentDetail'
import FinanceRepaymentExceptionListView from '../views/lender/Finance/FinanceRepaymentExceptionList'
import FinanceRepaymentRepayOfflineView from '../views/lender/Finance/FinanceRepaymentRepayOffline'

import FinanceCashJournalView from '../views/lender/Finance/FinancingCashJournal'
import FinanceCashJournalPayListView from '../views/lender/Finance/FinancingCashJournalPayList'
import FinanceCashJournalRepayListView from '../views/lender/Finance/FinancingCashJournalRepayList'
import FinanceCashJournalRefundListView from '../views/lender/Finance/FinanceCashJournalRefundList'

import ReportingIndexView from '../views/lender/Reporting/ReportingIndex'
import ReportingOverdueListView from '../views/lender/Reporting/ReportingOverdueList'
import ReportingFinanceListView from '../views/lender/Reporting/ReportingFinanceList'

import MessageIndexView from '../views/lender/Message/Message'
import MessageListView from '../views/lender/Message/MessageList'

import DealerListView from '../views//dealer/DealerList'
import DealerView from '../views//dealer/Dealer'
import DealerAddView from '../views//dealer/DealerAdd'
import DealerEditView from '../views//dealer/DealerEdit'

import DealerUserListView from '../views//dealer/DealerUserList'
import DealerUserView from '../views//dealer/DealerUser'
import DealerUserAddView from '../views//dealer/DealerUserAdd'

import CustomerApplyingFangView from '../views//dealer/CustomerApplying'
import CustomerApplyingListFangView from '../views//dealer/CustomerApplyingList'
import CustomerApplyingFangApproveKF from '../views/dealer/CustomerApplyingApproveKF'
import CustomerApplyingFangApprove from '../views/dealer/CustomerApplyingApprove'

import CustomerApplyingDetailView from '../views/dealer/CustomerApplyingDetail'
import CustomerApplyingVoidView from '../views//dealer/CustomerApplyingVoid'
import CustomerApplyingVoidListView from '../views//dealer/CustomerApplyingVoidList'

import CustomerFangView from '../views/dealer/Customer'
import CustomerListFangView from '../views/dealer/CustomerList'
import CustomerViewView from '../views/dealer/CustomerView'

import FinancingView from '../views/dealer/Financing'
import FinancingListView from '../views/dealer/FinancingList'
import FinancingViewListView from '../views/dealer/FinancingViewList'
import FinancingAddView from '../views/dealer/FinancingAdd'
import CustomerFinancingListView from '../views/dealer/CustomerFinancingList'
import CustomerFinancingDetailView from '../views/dealer/CustomerFinancingDetail'
import CustomerPrintDetailView from '../views/dealer/CustomerPrintDetail'


import CustomerApproveListView from '../views/dealer/CustomerApproveList'
import ApproveFinancingView from '../views/dealer/ApproveFinancing'
import PayFinancingListView from '../views/dealer/PayFinancingList'
import PaymentView from '../views/dealer/Payment'
import PaymentFinancingView from '../views/dealer/PaymentFinancing'
import RepayFinancingListView from '../views/dealer/RepayFinancingList'
import RepaymentView from '../views/dealer/Repayment'
import RepayFinancingView from '../views/dealer/RepayFinancing'

import FangReportingOverdueListView from '../views/dealer/FangReportingOverdueList'
import FangReportingView from '../views/dealer/FangReporting'
import FangReportingFinanceListView from '../views/dealer/FangReportingFinanceList'
import FinancingRepaymentListView from '../views/dealer/FinancingRepaymentList'
import FinancingRepaymentView from '../views/dealer/FinancingRepayment'


import FangFinanceAmountByMonthListView from '../views/dealer/FangFinanceAmountByMonthList'
import OutstandingMonthlyListView from '../views/fang/OutstandingMonthlyList'
import OutstandingDailyView from '../views/fang/OutstandingDaily'
import OutstandingDetailView from '../views/fang/OutstandingDetail'

import FangFinanceAmountByDayListView from '../views/dealer/FangFinanceAmountByDayList'
import FangFinanceAmountDetailListView from '../views/dealer/FangFinanceAmountDetailList'

import ImportBankTally from '../views/fang/ImportBankTallyView'
import ImportBankTallyView from '../views/fang/ImportBankTally'
import ImportBankTallyLog from '../views/fang/ImportBankTallyLog'
import ImportBankTallyLogListView from '../views/fang/ImportBankTallyLogList'
import TransferRepayment from '../views/fang/TransferRepayment'
import TransferRepaymentListView from '../views/fang/TransferRepaymentList'
import TransferRepaymentEditView from '../views/fang/TransferRepaymentEdit'
import TransferRepaymentFinance from '../views/fang/TransferRepaymentFinance'
import TransferRepaymentFinanceListView from '../views/fang/TransferRepaymentFinanceList'
import InfoSupplyListView from '../views/fang/InfoSupplyList'
import InfoSupply from '../views/fang/InfoSupply'
import InfoSupplyAddView from '../views/fang/InfoSupplyAdd'
import RepaymentEditView from '../views/fang/RepaymentEdit'
import OutstandingListView from '../views/fang/OutstandingList'

import ApplyingRepayment from '../views/fang/ApplyingRepayment'
import ApplyingRepaymentListView from '../views/fang/ApplyingRepaymentList'
import ApplyingRepaymentEditView from '../views/fang/ApplyingRepaymentEdit'
import ApplyingRepaymentViewView from '../views/fang/ApplyingRepaymentView'
import RepayReportByMonthListView from '../views/fang/RepayReportByMonthList'
import ApplyingRepaymentInAdvanceListView from '../views/fang/ApplyingRepaymentInAdvanceList'
import ApplyingRepaymentInAdvance from '../views/fang/ApplyingRepaymentInAdvance'
import ApplyingRepaymentInAdvanceEditView from '../views/fang/ApplyingRepaymentInAdvanceEdit'
import FangCustomerView from '../views/fang/FangCustomer'
import CreateCustomerView from '../views/fang/CreateCustomer'
import ApplyingRepaymentInAdvanceApproveView from '../views/fang/ApplyingRepaymentInAdvanceApprove'
import ApplyingRepaymentInAdvanceApproveViewView from '../views/fang/ApplyingRepaymentInAdvanceView'

import BankStatementSummary from '../views/fang/BankStatementSummary'
import BankStatementSummaryListView from '../views/fang/BankStatementSummaryList'
import BankStatementUseListView from '../views/fang/BankStatementUseList'

import HelpFileView from '../views/lender/Message/HelpFile'
import EditionView from '../views/fang/Edition'
import RepaymentExcessAmountListView from '../views/fang/RepaymentExcessAmountList'

import InterestConfirmListView from '../views/fang/InterestConfirmList'
import InterestConfirmView from '../views/fang/InterestConfirm'
import InterestConfirmViewView from '../views/fang/InterestConfirmView'
import InterestReviewListView from '../views/fang/InterestReviewList'
import FirstFinancingListView from '../views/fang/FirstFinancingList'
import FirstFinancing from '../views/fang/FirstFinancing'
import CustomerEditView from '../views/dealer/CustomerEdit'
import LoanApplyListView from '../views/fang/LoanApplyList'
import LoanApplyView from '../views/fang/LoanApply'
import LoanApproveView from '../views/fang/LoanApprove'
import SubmenuPage from "../views/components/SubmenuPage";
import LoanApprovalListView from '../views/fang/LoanApprovalList'
import LoanApprovalView from '../views/fang/LoanApproval'
import LoanApprovedView from '../views/fang/LoanApproved'
import LoanApprovedViewView from '../views/fang/LoanApprovedView'
import PayFinancingTLT1View from '../views/fang/PayFinancingTLT1'
import PayFinancingTLT2View from '../views/fang/PayFinancingTLT2'
import PayFinancingBANKTRANSFERView from '../views/fang/PayFinancingBANKTRANSFER'
import LoanRecordListView from '../views/fang/LoanRecordList'
import LoanRecord from '../views/fang/LoanRecord'
import LoanRecordView from '../views/fang/LoanRecordView'
import FinancingPaymentListView from '../views/fang/FinancingPaymentList'
import OutstandingToDateOldListView from '../views/fang/OutstandingToDateOldList'
import CustomerListView from '../views/fang/CustomerList'
import CustomerView from '../views/fang/Customer'
import FangCustomerViewView from '../views/fang/CustomerView'
import InterestRevenueListView from '../views/fang/InterestRevenueList'

import VoidFinancingView from '../views/fang/VoidFinancing'
import VoidFinancingListView from '../views/fang/VoidFinancingList'
import DepositApplicationForApprovalView  from '../views/fang/DepositApplicationForApproval'
import DepositApplicationForApprovalListView  from '../views/fang/DepositApplicationForApprovalList'
import DepositApplicationDAView  from '../views/fang/DepositApplicationDA'
import DepositApplicationDRView  from '../views/fang/DepositApplicationDR'
import ApproveDepositApplication  from '../views/fang/ApproveDepositApplication'
import DepositBalanceView  from '../views/fang/DepositBalance'
import DepositBalanceListView  from '../views/fang/DepositBalanceList'
import DepositTxListView  from '../views/fang/DepositTxList'
import FinancingWithDepositListView  from '../views/fang/FinancingWithDepositList'

import FinancingRequestListView  from '../views/fang/FinancingRequestList'
import FinancingRequestView  from '../views/fang/FinancingRequest'
import FinancingRequestViewView  from '../views/fang/FinancingRequestView'

import HisWarrantView  from '../views/fang/HisWarrant'
import HisWarrantListView  from '../views/fang/HisWarrantList'
import HisWarrantCheckoutView  from '../views/fang/HisWarrantCheckout'
import HisWarrantCheckoutListView  from '../views/fang/HisWarrantCheckoutList'
import HisWarrantApproveListView  from '../views/fang/HisWarrantApproveList'
import HisWarrantApproveView  from '../views/fang/HisWarrantApprove'
import HisWarrantApproveViewView  from '../views/fang/HisWarrantApproveView'
import CustomerLenderViewView from '../views/fang/CustomerLenderView'
import ProxyPersonView from '../views/fang/ProxyPerson'
import ProxyPersonListView from '../views/fang/ProxyPersonList'
import ProxyPersonAddView from '../views/fang/ProxyPersonAdd'
import OutstandingMonthly2021ListView from '../views/fang/OutstandingMonthly2021List'
import OutstandingDaily2021View from '../views/fang/OutstandingDaily2021'
import OutstandingDetail2021View from '../views/fang/OutstandingDetail2021'
import ThreeTierRebateListView from '../views/fang/ThreeTierRebateList'
import RepaymentPlanListView from '../views/fang/RepaymentPlanList'
import FinancingReportListView from '../views/fang/FinancingList'
import LenderRebateListView from '../views/fang/LenderRebateList'
import DealerRebateListView from '../views/fang/DealerRebateList'
import CustomerWeihuView from '../views/fang/CustomerWeihu'
import BusinessPartnerView from '../views/fang/BusinessPartner'
import BusinessPartnerListView from '../views/fang/BusinessPartnerList'
import BusinessPartnerAddView from '../views/fang/BusinessPartnerAdd'
import DebtTransferListView from '../views/fang/DebtTransferList'
import DebtTransferView from '../views/fang/DebtTransfer'
import EquitySwapPartnerAddView from '../views/fang/EquitySwapPartnerAdd'
import EquitySwapTxListView from '../views/fang/EquitySwapTxList'
import EquitySwapTxView from '../views/fang/EquitySwapTx'
import EquitySwapTxAddView from '../views/fang/EquitySwapTxAdd'
import EquitySwapTxViewView from '../views/fang/EquitySwapTxView'
import ApproveEquitySwapTxListView from '../views/fang/ApproveEquitySwapTxList'
import ApproveEquitySwapTxView from '../views/fang/ApproveEquitySwapTx'
import ApproveEquitySwapTxViewListView from '../views/fang/ApproveEquitySwapTxViewList'

import RepaymentWithExcessAmountListView from '../views/fang/RepaymentWithExcessAmountList'
import RepaymentWithExcessAmount from '../views/fang/RepaymentWithExcessAmount'
import ContractSealProcessView from '../views/fang/ContractSealProcess'
import ContractSealProcessViewView from '../views/fang/ContractSealProcessView'
import ContractSealProcessListView from '../views/fang/ContractSealProcessList'
import ApproveContractSealProcessView from '../views/fang/ApproveContractSealProcess'
import ApproveContractSealProcessViewView from '../views/fang/ApproveContractSealProcessView'

import ContractSealProcessCYView from '../views/fang/ContractSealProcessCY'
import ContractSealProcessSSView from '../views/fang/ContractSealProcessSS'
import ContractSealProcessZZView from '../views/fang/ContractSealProcessZZ'
import ContractSealProcessZDHView from '../views/fang/ContractSealProcessZDH'
import ContractSealProcessFWFView from '../views/fang/ContractSealProcessFWF'
import ContractSealProcessTYView from '../views/fang/ContractSealProcessTY'

import ApproveContractSealProcessZDHView from '../views/fang/ApproveContractSealProcessZDH'
import ApproveContractSealProcessZDHViewView from '../views/fang/ApproveContractSealProcessZDHView'
import ApproveContractSealProcessFWFView from '../views/fang/ApproveContractSealProcessFWF'
import ApproveContractSealProcessFWFViewView from '../views/fang/ApproveContractSealProcessFWFView'

import ApproveContractSealProcessTYView from '../views/fang/ApproveContractSealProcessTY'
import ApproveContractSealProcessTYViewView from '../views/fang/ApproveContractSealProcessTYView'



import ApproveContractSealProcessZZView from '../views/fang/ApproveContractSealProcessZZ'
import ApproveContractSealProcessZZViewView from '../views/fang/ApproveContractSealProcessZZView'
import HisWarrantPrintView from '../views/fang/HisWarrantPrint'


import Monitor from "../views/monitor/index";
import MonitorB from "../views/monitor/index_b";


import BranchOfficeView from '../views/branchoffice/BranchOffice'
import BranchOfficeListView from '../views/branchoffice/BranchOfficeList'
import BranchOfficeAddView from '../views/branchoffice/BranchOfficeAdd'

import BranchUserListView from '../views/branchoffice/BranchUserList'
import BranchUserView from '../views/branchoffice/BranchUser'
import BranchUserAddView from '../views/branchoffice/BranchUserAdd'

import BranchAllocationListView from '../views/branchoffice/BranchAllocationList'
import BranchAllocationView from '../views/branchoffice/BranchAllocation'

import BranchAppointmentView from '../views/branchoffice/BranchAppointment'
import BranchAppointmentListView from '../views/branchoffice/BranchAppointmentList'
import ApproveBranchAppointmentView from '../views/branchoffice/ApproveBranchAppointment'

import BranchAppointmentViewListView from '../views/branchoffice/BranchAppointmentViewList'
import BranchAppointmentViewView from '../views/branchoffice/BranchAppointmentView'
import signingView from '../views/branchoffice/signing'




import BranchAssignmentView from '../views/branchoffice/BranchAssignment'
import BranchAssignmentListView from '../views/branchoffice/BranchAssignmentList'
import BranchAssignmentAddView from '../views/branchoffice/BranchAssignmentAdd'
import BranchAssignmentViewView from '../views/branchoffice/BranchAssignmentView'

import BranchNoticeView from '../views/branchoffice/BranchNotice'
import BranchNoticeListView from '../views/branchoffice/BranchNoticeList'
import BranchNoticeAddView from '../views/branchoffice/BranchNoticeAdd'

import BranchMessageView from '../views/branchoffice/BranchMessage'
import BranchMessageListView from '../views/branchoffice/BranchMessageList'
import BranchMessageAddView from '../views/branchoffice/BranchMessageAdd'
import BranchMessageViewView from '../views/branchoffice/BranchMessageView'

import FaihaiQueryList from '../views/fang/FaihaiQuery'
import FaihaiQueryView from '../views/fang/FaihaiQueryView'
import FaihaiQueryPersonView from '../views/fang/FaihaiQueryPersonView'
import FaihaiQueryPersonDetailView from '../views/fang/FaihaiQueryPersonDetailView'
import FaihaiQueryEnterpriseView from '../views/fang/FaihaiQueryEnterpriseView'








Vue.use(Router)

const component = {
    template: "<router-view style='width:100%'></router-view>"
}

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/logon'
        },
        {
            path: '/403',
            name: '403',
            component: ForbiddenView
        },
        {
            path: '/logon',
            name: 'logon',
            component: LogonView
        },
        {
            path: '/monitor',
            name: 'Monitor',
            component: Monitor
        },
        {
            path: '/monitor_B',
            name: 'MonitorB',
            component: MonitorB
        },
        {
            path: '/prototype',
            name: 'HTML原型',
            component: Prototype
        },
        {
            path: '/pages',
            component: ()=>import('../views/PagesView'),
            children: [
                {
                    path: '',
                    redirect: 'home'
                },
                {
                    path: 'FangMonitor',
                    redirect: {name: 'Monitor'}
                },
                {
                    path: 'FangMonitor_B',
                    redirect: {name: 'MonitorB'}
                },
                {
                    path: 'home',
                    name: 'LenderHome',
                    component: LenderHome
                },
                {
                    path: 'config',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'Setting',
                            component: ConfigSettingView,
                            children: [
                                {
                                    path: '',
                                    name: 'ConfigSettingView',
                                    redirect: 'Financing'
                                },
                                {
                                    path: 'Financing',
                                    component: ConfigSettingFinancingView
                                }
                            ]
                        },
                        {
                            path: 'user',
                            component: ConfigUserView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'list'
                                },
                                {
                                    path: 'list',
                                    name: 'ConfigUserListView',
                                    component: ConfigUserListView
                                },
                                {
                                    path: 'add',
                                    component: ConfigUserEditView
                                },
                                {
                                    path: 'edit',
                                    component: ConfigUserAddView
                                },
                                {
                                    path: 'detail',
                                    component: ConfigUserDetailView
                                }
                            ]
                        },
                        {
                            path: 'role',
                            component: ConfigRoleView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'list'
                                },
                                {
                                    path: 'list',
                                    name: 'ConfigRoleListView',
                                    component: ConfigRoleListView
                                },
                                {
                                    path: 'edit',
                                    component: ConfigRoleEditView
                                },
                                {
                                    path: 'functionedit',
                                    component: ConfigRoleFunctionEditView
                                }
                            ]
                        },
                        {
                            path: 'Department',
                            component: ConfigDepartmentView,
                            children: [
                                {
                                    path: '',
                                    name: 'ConfigDepartmentView',
                                    redirect: 'List'
                                },
                                {
                                    path: 'List',
                                    name: 'ConfigDepartmentListView',
                                    component: ConfigDepartmentListView
                                },
                                {
                                    path: 'Edit',
                                    name: 'ConfigDepartmentEditView',
                                    component: ConfigDepartmentEditView
                                }
                            ]
                        },
                        {
                            path: 'Product',
                            component: ServiceAdminProductView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List'
                                },
                                {
                                    path: 'List',
                                    name: 'ServiceAdminProductListView',
                                    component: ServiceAdminProductListView
                                },
                                {
                                    path: 'Edit',
                                    name: 'ServiceAdminProductEditView',
                                    component: ServiceAdminProductEditView
                                },
                                {
                                    path: 'Detail',
                                    component: ServiceAdminProductDetailView
                                }
                            ]
                        },
                        {
                            path: 'BankAccount',
                            component: ServiceAdminBankAccountView,
                            children: [
                                {
                                    path: '',
                                    name: 'ServiceAdminBankAccountView',
                                    redirect: 'List'
                                },
                                {
                                    path: 'List',
                                    component: ServiceAdminBankAccountListView
                                }
                            ]
                        },
                        {
                            path: 'ProxyPerson',
                            component: ProxyPersonView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'ProxyPersonListView',
                                    component: ProxyPersonListView
                                },
                                {
                                    path: 'Add',
                                    name: 'ProxyPersonAddView',
                                    component: ProxyPersonAddView
                                },


                            ]
                        },

                    ]
                },

                {
                    path: 'CustomerAdmin',
                    name: 'CustomerView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'Customer',
                            component: CustomerCustomerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'CustomerDetail',
                                    component: CustomerCustomerDetailView
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerCustomerListView',
                                    component: CustomerCustomerListView
                                },
                                {
                                    path: 'Edit',
                                    component: CustomerCustomerEditView
                                },
                            ]
                        },
                        {
                            path: 'Debtor',
                            component: CustomerDebtorView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerAdminDebtorList',
                                    component: CustomerDebtorListView
                                },
                                {
                                    path: 'Edit',
                                    component: CustomerDebtorEditView
                                }
                            ]
                        },
                        {
                            path: 'CustomerApplying',
                            component: CustomerApplyingCustomerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerApplyingCustomerList',
                                    component: CustomerApplyingCustomerListView
                                },
                                {
                                    path: 'Detail',
                                    name: 'CustomerAdminCustomerApplying',
                                    component: CustomerApplyingCustomerDetailView
                                },
                                {
                                    path: 'ApproveKF',
                                    name: 'CustomerApplyingCustomerApproveKF',
                                    component: CustomerApplyingCustomerApproveKFView
                                },
                                {
                                    path: 'Approve',
                                    name: 'CustomerApplyingCustomerApprove',
                                    component: CustomerApplyingCustomerApproveView
                                },
                                {
                                    path: 'ApproveZJL',
                                    name: 'CustomerApplyingCustomerApproveZJL',
                                    component: CustomerApplyingCustomerApproveZJLView
                                },
                                {
                                    path: 'ApproveDSZ',
                                    name: 'CustomerApplyingCustomerApproveDSZ',
                                    component: CustomerApplyingCustomerApproveDSZView
                                },
                                {
                                    path: 'ApproveZS',
                                    name: 'CustomerApplyingCustomerApproveZS',
                                    component: CustomerApplyingCustomerApproveZSView
                                },
                                {
                                    path: 'BankAP',
                                    name: 'CustomerApplyingBankAP',
                                    component: CustomerApplyingCustomerBankAPView
                                },

                            ]
                        },

                        {
                            path: 'CustomerApplyingVehicleMortgage',
                            component: CustomerApplyingVehicleMortgageCustomerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerApplyingVehicleMortgageCustomerList',
                                    component: CustomerApplyingVehicleMortgageCustomerListView
                                },
                                {
                                    path: 'Detail',
                                    name: 'CustomerApplyingVehicleMortgageCustomerDetail',
                                    component: CustomerApplyingVehicleMortgageCustomerDetailView
                                },
                                {
                                    path: 'Approve',
                                    name: 'CustomerApplyingVehicleMortgageCustomerApprove',
                                    component: CustomerApplyingVehicleMortgageCustomerApproveView
                                }
                            ]
                        },
                        {
                            path: 'DebtorUser',
                            component: CustomerDebtorUserView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerAdminDebtorUserList',
                                    component: CustomerDebtorUserListView
                                },
                                {
                                    path: 'Edit',
                                    component: CustomerDebtorUserEditView
                                }
                            ]
                        },
                        {
                            path: 'CustomerUser',
                            component: CustomerUserView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerAdminCustomerUserList',
                                    component: CustomerUserListView
                                },
                                {
                                    path: 'Edit',
                                    component: CustomerUserEditView
                                }
                            ]
                        }
                    ]

                },
                {
                    path: 'ServiceAdmin',
                    name: 'ServiceAdmin',
                    component: {
                        template: "<router-view />",
                    },

                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'Credit',
                            component: ServiceAdminCreditView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    component: ServiceAdminCreditListView
                                },
                                {
                                    path: 'Detail',
                                    component: ServiceAdminCreditDetailView
                                },
                                {
                                    path: 'Edit',
                                    component: ServiceAdminCreditEditView
                                }
                            ]
                        },
                        {
                            path: 'Contract',
                            component: ServiceAdminContractView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List'
                                },
                                {
                                    path: 'ApplyingList',
                                    name: 'ServerAdminContractApplyingList',
                                    component: ServiceAdminContractApplyingListView
                                },
                                {
                                    path: 'ApplyingDetail',
                                    component: ServiceAdminContractApplyingDetailView
                                },
                                {
                                    path: 'List',
                                    component: ServiceAdminContractListView,
                                },
                                {
                                    path: 'Detail',
                                    component: ServiceAdminContractDetailView
                                }
                            ]
                        },
                        {
                            path: 'Pledge',
                            component: ServiceAdminPledgeView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List'
                                },
                                {
                                    path: 'ApplyingList',
                                    name: 'ServerAdminPledgeApplyingList',
                                    component: ServiceAdminPledgeApplyingListView
                                },
                                {
                                    path: 'ApplyingDetail',
                                    component: ServiceAdminPledgeApplyingDetailView
                                },
                                {
                                    path: 'List',
                                    component: ServiceAdminPledgeListView,
                                },
                                {
                                    path: 'Detail',
                                    component: ServiceAdminPledgeDetailView
                                },
                                {
                                    path: 'InvoiceList',
                                    component: ServiceAdminPledgeInvoiceListView
                                },
                                {
                                    path: 'InvoiceDetail',
                                    component: ServiceAdminPledgeInvoiceDetailView
                                }
                            ]
                        },
                        {
                            path: 'Financing',
                            component: ServiceAdminFinancingView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List'
                                },
                                {
                                    path: 'ApplyingList',
                                    name: 'ServiceAdminFinancingApplyingListView',
                                    component: ServiceAdminFinancingApplyingListView
                                },
                                {
                                    path: 'ApplyingDetail',
                                    component: ServiceAdminFinancingApplyingDetailView
                                },
                                {
                                    path: 'List',
                                    component: ServiceAdminFinancingListView,
                                },
                                {
                                    path: 'Detail',
                                    name: 'ServiceAdminFinancingDetail',
                                    component: ServiceAdminFinancingDetailView
                                },
                                {
                                    path: 'Repay',
                                    component: ServiceAdminFinancingRepayView
                                },
                                {
                                    path: 'RepaymentList',
                                    component: ServiceAdminFinancingRepaymentListView
                                },
                                {
                                    path: 'RepayDetail',
                                    component: ServiceAdminFinancingRepayDetailView
                                },
                                {
                                    path: 'CustomerList',
                                    component: ServiceAdminCustomerListView
                                },
                                {
                                    path: 'CashJournalList',
                                    component: ServiceAdminCashJournalListView
                                }
                            ]
                        },
                    ]
                },
                {
                    path: 'Finance',
                    name: 'FinanceView',
                    component: {
                        template: '<router-view />'
                    },
                    children: [
                        {
                            path: '',
                            redirect: 'Index'
                        },
                        {
                            path: 'Index',
                            component: FinanceIndex
                        },
                        {
                            path: 'Payment',
                            component: FinancePaymentView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'PendingPayList'
                                },
                                {
                                    path: 'PendingPayList',
                                    name: 'FinancePaymentPendingPayListView',
                                    component: FinancePaymentPendingPayListView
                                },
                                {
                                    path: 'Detail',
                                    component: FinancePaymentDetailView
                                },
                            ]
                        },
                        {
                            path: 'Repayment',
                            component: FinanceRepaymentView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List'
                                },
                                {
                                    path: 'List',
                                    component: FinanceRepaymentListView
                                },
                                {
                                    path: 'Detail',
                                    component: FinanceRepaymentDetailView
                                },
                                {
                                    path: 'RepayOffline',
                                    component: FinanceRepaymentRepayOfflineView
                                },
                                {
                                    path: 'ExceptionList',
                                    component: FinanceRepaymentExceptionListView
                                }
                            ]
                        },
                        {
                            path: 'CashJournal',
                            component: FinanceCashJournalView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'PayList'
                                },
                                {
                                    path: 'PayList',
                                    component: FinanceCashJournalPayListView
                                },
                                {
                                    path: 'RepayList',
                                    component: FinanceCashJournalRepayListView
                                },
                                {
                                    path: 'RefundList',
                                    component: FinanceCashJournalRefundListView
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'Reporting',
                    name: 'ReportingView',
                    component: {
                        template: '<router-view />'
                    },
                    children: [
                        {
                            path: '',
                            redirect: 'OverdueList'
                        },
                        {
                            path: 'OverdueList',
                            component: ReportingOverdueListView

                        },
                        {
                            path: 'ReportingFinanceList',
                            component: ReportingFinanceListView

                        }
                    ]
                },
                {
                    path: 'Message',
                    name: 'Message',
                    component: {
                        template: '<router-view />'
                    },
                    children: [
                        {
                            path: '',
                            redirect: 'List'
                        },
                        {
                            path: 'List',
                            name: 'MessageList',
                            component: MessageListView
                        },
                        {
                            path: 'HelpFile',
                            name: 'HelpFile',
                            component: HelpFileView
                        },
                        {
                            path: 'Edition',
                            name: 'Edition',
                            component: EditionView
                        }
                    ]
                },
                {
                    path: 'FangDealer',
                    name: 'DealerwwView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'DealerList',
                            component: DealerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'DealerListView',
                                    component: DealerListView
                                },
                                {
                                    path: 'add',
                                    name: 'DealerAddView',
                                    component: DealerAddView
                                },
                                {
                                    path: 'edit',
                                    name: 'DealerEditView',
                                    component: DealerEditView
                                },
                            ]
                        },
                        {
                            path: 'DealerUserList',
                            component: DealerUserView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'DealerUserListView',
                                    component: DealerUserListView
                                },
                                {
                                    path: 'add',
                                    name: 'DealerUserAddView',
                                    component: DealerUserAddView
                                },
                                /*{
                                  path: 'edit',
                                  name: 'DealerEditView',
                                  component: DealerEditView
                                },*/
                            ]
                        },
                        {
                            path: 'DepositApplicationForApprovalList',
                            component: DepositApplicationForApprovalView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'DepositApplicationForApprovalListView',
                                    component: DepositApplicationForApprovalListView
                                },
                                {
                                    path: 'addDA',
                                    name: 'DepositApplicationDAView',
                                    component: DepositApplicationDAView
                                },
                                {
                                    path: 'addDR',
                                    name: 'DepositApplicationDRView',
                                    component: DepositApplicationDRView
                                },
                                {
                                    path: 'approve',
                                    name: 'ApproveDepositApplication',
                                    component: ApproveDepositApplication
                                },
                            ]
                        },
                        {
                            path: 'DepositBalanceList',
                            component: DepositBalanceView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'DepositBalanceListView',
                                    component: DepositBalanceListView
                                },
                                {
                                    path: 'DepositTxList',
                                    name: 'DepositTxListView',
                                    component: DepositTxListView
                                },
                                {
                                    path: 'FinancingWithDepositList',
                                    name: 'FinancingWithDepositListView',
                                    component: FinancingWithDepositListView
                                },
                            ]
                        },
                        {
                            path: 'BusinessPartner',
                            component: BusinessPartnerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'BusinessPartnerListView',
                                    component: BusinessPartnerListView
                                },
                                {
                                    path: 'Add',
                                    name: 'BusinessPartnerAddView',
                                    component: BusinessPartnerAddView
                                },


                            ]
                        },
                        {
                            path: 'DebtTransfer',
                            component: DebtTransferView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'DebtTransferList',
                                    component: DebtTransferListView
                                },
                                {
                                    path: 'add',
                                    name: 'EquitySwapPartnerAdd',
                                    component: EquitySwapPartnerAddView
                                },

                            ]
                        },
                        {
                            path: 'LenderList',
                            component: () => import('../views/fang/Lenders'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'LenderListView',
                                    component: () => import('../views/fang/LenderList'),
                                },
                                {
                                    path: 'add',
                                    name: 'LenderAdd',
                                    component: () => import('../views/fang/LenderAdd'),
                                },
                                {
                                    path: 'edit',
                                    name: 'LenderEdit',
                                    component: () => import('../views/fang/LenderAdd'),
                                },
                            ]
                        },
                        {
                            path: 'LenderUserList',
                            component: () => import('../views/fang/LenderUser'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'LenderUserListView',
                                    component: () => import('../views/fang/LenderUserList'),
                                },
                                {
                                    path: 'add',
                                    name: 'LenderUserAdd',
                                    component: () => import('../views/fang/LenderUserAdd'),
                                },
                                {
                                    path: 'edit',
                                    name: 'LenderEdit',
                                    component: () => import('../views/fang/LenderUserAdd'),
                                },
                            ]
                        },
                    ]

                },
                {
                    path: 'FangLender',
                    name: 'LenderView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },

                        {
                            path:'LenderApplyList',
                            component: () => import('../views/fang/LenderApply'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'LenderApplyListView',
                                    component: () => import('../views/fang/LenderApplyList'),
                                },
                                {
                                    path: 'view',
                                    name: 'LenderApplyView',
                                    component: () => import('../views/fang/LenderApplyView'),
                                },
                            ]
                        },
                        {
                            path:'AllocationCandidates',
                            name:'AllocationCandidatesView',
                            component: () => import('../views/fang/AllocationCandidates'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'AllocationCandidatesListView',
                                    component: () => import('../views/fang/AllocationCandidatesList'),
                                },

                            ]
                        },
                        {
                            path:'Allocation',
                            component: () => import('../views/fang/Allocation'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'AllocationListView',
                                    component: () => import('../views/fang/AllocationList'),
                                },
                                {
                                    path: 'CustomerLenderView',
                                    name: 'CustomerLenderViewView',
                                    component: () => import('../views/fang/CustomerLenderView'),
                                },
                            ]
                        },

                    ]

                },
                {
                    path: 'FangLender',
                    name: 'LenderView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'LenderList',
                            component: () => import('../views/fang/Lenders'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'LenderListView',
                                    component: () => import('../views/fang/LenderList'),
                                },
                                {
                                    path: 'add',
                                    name: 'LenderAdd',
                                    component: () => import('../views/fang/LenderAdd'),
                                },
                                {
                                    path: 'edit',
                                    name: 'LenderEdit',
                                    component: () => import('../views/fang/LenderAdd'),
                                },
                            ]
                        },
                        {
                            path: 'LenderUserList',
                            component: () => import('../views/fang/LenderUser'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'LenderUserListView',
                                    component: () => import('../views/fang/LenderUserList'),
                                },
                                {
                                    path: 'add',
                                    name: 'LenderUserAdd',
                                    component: () => import('../views/fang/LenderUserAdd'),
                                },
                                {
                                    path: 'edit',
                                    name: 'LenderEdit',
                                    component: () => import('../views/fang/LenderUserAdd'),
                                },
                            ]
                        },
                        {
                            path:'LenderApplyList',
                            component: () => import('../views/fang/LenderApply'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'LenderApplyListView',
                                    component: () => import('../views/fang/LenderApplyList'),
                                },
                                {
                                    path: 'view',
                                    name: 'LenderApplyView',
                                    component: () => import('../views/fang/LenderApplyView'),
                                },
                            ]
                        },
                        {
                            path:'AllocationCandidates',
                            name:'AllocationCandidatesView',
                            component: () => import('../views/fang/AllocationCandidates'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'AllocationCandidatesListView',
                                    component: () => import('../views/fang/AllocationCandidatesList'),
                                },

                            ]
                        },
                        {
                            path:'Allocation',
                            component: () => import('../views/fang/Allocation'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'AllocationListView',
                                    component: () => import('../views/fang/AllocationList'),
                                },
                                {
                                    path: 'CustomerLenderView',
                                    name: 'CustomerLenderViewView',
                                    component: () => import('../views/fang/CustomerLenderView'),
                                },
                            ]
                        },

                    ]

                },
                {
                    path: 'Fang',
                    name: 'FangView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'CustomerApplying',
                            component: CustomerApplyingFangView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerApplyingListFangView',
                                    component: CustomerApplyingListFangView
                                },
                                {
                                    path: 'KF',
                                    name: 'CustomerApplyingFangApproveKF',
                                    component: CustomerApplyingFangApproveKF
                                },
                                {
                                    path: 'Other',
                                    name: 'CustomerApplyingFangApprove',
                                    component: CustomerApplyingFangApprove
                                },
                                {
                                    path: 'CustomerApplyingDetail',
                                    name: 'CustomerApplyingDetailView',
                                    component: CustomerApplyingDetailView
                                },
                            ]
                        },
                        {
                            path: 'CustomerApplyingVoid',
                            component: CustomerApplyingVoidView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerApplyingVoidList',
                                    component: CustomerApplyingVoidListView
                                },
                            ]
                        },

                        {
                            path:'CustomerFang',
                            component: CustomerFangView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerListFangView',
                                    component: CustomerListFangView
                                },

                                {
                                    path: 'CustomerView',
                                    name: 'CustomerViewView',
                                    component: CustomerViewView
                                },
                                {
                                    path: 'CustomerEdit',
                                    name: 'CustomerEditView',
                                    component: CustomerEditView
                                },
                            ]
                        },
                        {
                            path: 'CustomerWeihu',
                            component: CustomerFangView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerWeihuView',
                                    component: CustomerWeihuView
                                },
                                {
                                    path: 'CustomerEdit',
                                    name: 'CustomerEditView',
                                    component: CustomerEditView
                                }
                            ]
                        },

                        {
                            path:'FangCustomer',
                            component: FangCustomerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'Create',
                                },
                                {
                                    path: 'Create',
                                    name: 'CreateCustomer',
                                    component: CreateCustomerView
                                },
                            ]
                        },
                        {
                            path: 'CustomerList',
                            component: CustomerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerList',
                                    component: CustomerListView
                                },
                                {
                                    path: 'View',
                                    name: 'FangCustomerViewView',
                                    component: FangCustomerViewView
                                },

                            ]
                        },
                        {
                            path: 'FinancingRequest',
                            component: FinancingRequestView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'FinancingRequestListView',
                                    component: FinancingRequestListView
                                },
                                {
                                    path: 'View',
                                    name: 'FinancingRequestView',
                                    component: FinancingRequestViewView
                                },

                            ]
                        },
                        {
                            path: 'FaihaiQuery',
                            component: FaihaiQueryView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'FaihaiQueryList',
                                    component: FaihaiQueryList
                                },
                                {
                                    path: 'FaihaiQueryPerson',
                                    name: 'FaihaiQueryPersonView',
                                    component: FaihaiQueryPersonView
                                },
                                {
                                    path: 'FaihaiQueryPersonDetail',
                                    name: 'FaihaiQueryPersonDetailView',
                                    component: FaihaiQueryPersonDetailView
                                },
                                {
                                    path: 'FaihaiQueryEnterprise',
                                    name: 'FaihaiQueryEnterpriseView',
                                    component: FaihaiQueryEnterpriseView
                                },



                            ]
                        },
                    ]

                },
                {
                    path: 'FangDebtTransfer',
                    name: 'FangDebtTransferView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'DebtTransfer',
                            component: DebtTransferView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'DebtTransferList',
                                    component: DebtTransferListView
                                },
                                {
                                    path: 'add',
                                    name: 'EquitySwapPartnerAdd',
                                    component: EquitySwapPartnerAddView
                                },

                            ]
                        },
                        {
                            path: 'EquitySwapTx',
                            component: EquitySwapTxView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'EquitySwapTxList',
                                    component: EquitySwapTxListView
                                },
                                {
                                    path: 'add',
                                    name: 'EquitySwapTxAdd',
                                    component: EquitySwapTxAddView
                                },
                                {
                                    path: 'view',
                                    name: 'EquitySwapTxView',
                                    component: EquitySwapTxViewView
                                },
                            ]
                        },
                        {
                            path: 'ApproveEquitySwapTx',
                            component: EquitySwapTxView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'ApproveEquitySwapTxListView',
                                    component: ApproveEquitySwapTxListView
                                },
                                {
                                    path: 'approve',
                                    name: 'ApproveEquitySwapTxView',
                                    component: ApproveEquitySwapTxView
                                },
                                {
                                    path: 'add',
                                    name: 'EquitySwapTxAdd',
                                    component: EquitySwapTxAddView
                                },
                                {
                                    path: 'view',
                                    name: 'EquitySwapTxView',
                                    component: EquitySwapTxViewView
                                },
                            ]
                        },
                        {
                            path: 'ApproveEquitySwapTxView',
                            component: EquitySwapTxView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'ApproveEquitySwapTxViewListView',
                                    component: ApproveEquitySwapTxViewListView
                                },
                                {
                                    path: 'view',
                                    name: 'EquitySwapTxView',
                                    component: EquitySwapTxViewView
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'FangSealProcess',
                    name: 'FangSealProcessView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'ContractSealProcess',
                            component: ContractSealProcessViewView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'add',
                                },
                                {
                                    path: 'add',
                                    name: 'ContractSealProcessView',
                                    component: ContractSealProcessView
                                },
                            ],
                        },
                        {
                            path: 'ContractSealProcessCY',
                            component: ContractSealProcessViewView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'add',
                                },
                                {
                                    path: 'add',
                                    name: 'ContractSealProcessCYView',
                                    component: ContractSealProcessCYView
                                },
                            ],
                        },
                        {
                            path: 'ContractSealProcessSS',
                            component: ContractSealProcessViewView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'add',
                                },
                                {
                                    path: 'add',
                                    name: 'ContractSealProcessSSView',
                                    component: ContractSealProcessSSView
                                },
                            ],
                        },
                        {
                            path: 'ContractSealProcessZZ',
                            component: ContractSealProcessViewView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'add',
                                },
                                {
                                    path: 'add',
                                    name: 'ContractSealProcessZZView',
                                    component: ContractSealProcessZZView
                                },
                            ],
                        },
                        {
                            path: 'ContractSealProcessZDH',
                            component: ContractSealProcessViewView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'add',
                                },
                                {
                                    path: 'add',
                                    name: 'ContractSealProcessZDHView',
                                    component: ContractSealProcessZDHView
                                },
                            ],
                        },
                        {
                            path: 'ContractSealProcessFWF',
                            component: ContractSealProcessViewView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'add',
                                },
                                {
                                    path: 'add',
                                    name: 'ContractSealProcessFWFView',
                                    component: ContractSealProcessFWFView
                                },
                            ],
                        },
                        {
                            path: 'ContractSealProcessTY',
                            component: ContractSealProcessViewView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'add',
                                },
                                {
                                    path: 'add',
                                    name: 'ContractSealProcessTYView',
                                    component: ContractSealProcessTYView
                                },
                            ],
                        },



                        {
                            path: 'ContractSealProcessList',
                            component: ContractSealProcessViewView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },

                                {
                                    path: 'List',
                                    name: 'ContractSealProcessListView',
                                    component: ContractSealProcessListView
                                },
                                {
                                    path: 'ApproveContractSealProcess',
                                    name: 'ApproveContractSealProcessView',
                                    component: ApproveContractSealProcessView
                                },{
                                    path: 'View',
                                    name: 'ApproveContractSealProcessViewView',
                                    component: ApproveContractSealProcessViewView
                                },

                                {
                                    path: 'ApproveContractSealProcessZDH',
                                    name: 'ApproveContractSealProcessZDHView',
                                    component: ApproveContractSealProcessZDHView
                                },
                                {
                                    path: 'ZDHView',
                                    name: 'ApproveContractSealProcessZDHViewView',
                                    component: ApproveContractSealProcessZDHViewView
                                },
                                {
                                    path: 'ApproveContractSealProcessFWF',
                                    name: 'ApproveContractSealProcessFWFView',
                                    component: ApproveContractSealProcessFWFView
                                },
                                {
                                    path: 'FWFView',
                                    name: 'ApproveContractSealProcessFWFViewView',
                                    component: ApproveContractSealProcessFWFViewView
                                },
                                {
                                    path: 'ApproveContractSealProcessZZ',
                                    name: 'ApproveContractSealProcessZZView',
                                    component: ApproveContractSealProcessZZView
                                },
                                {
                                    path: 'ZZView',
                                    name: 'ApproveContractSealProcessZZViewView',
                                    component: ApproveContractSealProcessZZViewView
                                },

                                {
                                    path: 'ApproveContractSealProcessTY',
                                    name: 'ApproveContractSealProcessTYView',
                                    component: ApproveContractSealProcessTYView
                                },
                                {
                                    path: 'TYView',
                                    name: 'ApproveContractSealProcessTYViewView',
                                    component: ApproveContractSealProcessTYViewView
                                },

                            ],
                        },
                    ]
                },
                {
                    path: 'FangFinance',
                    name: 'FinancView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'Financing',
                            component: FinancingView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'FinancingListView',
                                    component: FinancingListView
                                },

                                {
                                    path: 'approve',
                                    name: 'ApproveFinancingView',
                                    component: ApproveFinancingView
                                },

                                {
                                    path: 'view',
                                    name: 'ApproveFinancingViewView',
                                    component: ApproveFinancingView
                                },

                            ]
                        },
                        {
                            path: 'FinancingView',
                            component: FinancingView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'FinancingViewListView',
                                    component: FinancingViewListView
                                },


                            ]
                        },
                        {
                            path: 'CustomerApproveList',
                            component: FinancingView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerApproveListView',
                                    component: CustomerApproveListView
                                },
                                {
                                    path: 'Add',
                                    name: 'FinancingAddView',
                                    component: FinancingAddView
                                },

                            ]
                        },
                        {
                            path: 'VoidFinancingList',
                            component: VoidFinancingView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'VoidFinancingListView',
                                    component: VoidFinancingListView
                                },
                            ]
                        },
                        {
                            path: 'LoanApplyList',
                            component: LoanApplyView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'LoanApplyListView',
                                    component: LoanApplyListView
                                },
                                {
                                    path: 'Approve',
                                    name: 'LoanApproveView',
                                    component: LoanApproveView
                                },
                            ]
                        },
                        {
                            path: 'LoanApprovalList',
                            component: LoanApprovalView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'LoanApprovalListView',
                                    component: LoanApprovalListView
                                },
                                {
                                    path: 'Approved',
                                    name: 'LoanApprovedView',
                                    component: LoanApprovedView
                                },
                                {
                                    path: 'View',
                                    name: 'LoanApprovedViewView',
                                    component: LoanApprovedViewView
                                },
                            ]
                        },
                        {
                            path: 'CustomerFinancingList',
                            component: FinancingView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'CustomerFinancingListView',
                                    component: CustomerFinancingListView
                                },
                                {
                                    path: 'CustomerFinancingDetail',
                                    name: 'CustomerFinancingDetailView',
                                    component: CustomerFinancingDetailView
                                },
                                {
                                    path: 'CustomerPrintDetail',
                                    name: 'CustomerPrintDetailView',
                                    component: CustomerPrintDetailView
                                },

                            ]
                        },
                        {
                            path: 'TransferRepaymentList',
                            component: TransferRepayment,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'TransferRepaymentList',
                                    component: TransferRepaymentListView
                                },
                                {
                                    path: 'OutstandingList',
                                    name: 'OutstandingList',
                                    component: OutstandingListView
                                },
                                {
                                    path: 'Edit',
                                    name: 'TransferRepaymentEdit',
                                    component: TransferRepaymentEditView
                                },
                            ]
                        },
                        {
                            path: 'TransferRepaymentFinanceList',
                            component: TransferRepaymentFinance,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'TransferRepaymentFinanceList',
                                    component: TransferRepaymentFinanceListView
                                },
                            ]
                        },
                        {
                            path: 'InfoSupplyList',
                            component: InfoSupply,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'InfoSupplyList',
                                    component: InfoSupplyListView
                                },
                                {
                                    path: 'Add',
                                    name: 'InfoSupplyAdd',
                                    component: InfoSupplyAddView
                                },
                            ]
                        },
                        {
                            path: 'ApplyingRepaymentList',
                            component: ApplyingRepayment,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'ApplyingRepaymentList',
                                    component: ApplyingRepaymentListView
                                },
                                {
                                    path: 'Edit',
                                    name: 'ApplyingRepaymentEdit',
                                    component: ApplyingRepaymentEditView
                                },
                                {
                                    path: 'View',
                                    name: 'ApplyingRepaymentView',
                                    component: ApplyingRepaymentViewView
                                },
                            ]
                        },
                        {
                            path: 'ApplyingRepaymentInAdvanceList',
                            component: ApplyingRepaymentInAdvance,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'ApplyingRepaymentInAdvanceList',
                                    component: ApplyingRepaymentInAdvanceListView
                                },
                                {
                                    path: 'Edit',
                                    name: 'ApplyingRepaymentInAdvanceEdit',
                                    component: ApplyingRepaymentInAdvanceEditView
                                },
                                {
                                    path: 'approve',
                                    name: 'ApplyingRepaymentInAdvanceApprove',
                                    component: ApplyingRepaymentInAdvanceApproveView
                                },
                                {
                                    path: 'view',
                                    name: 'ApplyingRepaymentInAdvanceApproveView',
                                    component: ApplyingRepaymentInAdvanceApproveViewView
                                },
                            ]
                        },
                        {
                            path: 'RepaymentWithExcessAmountList',
                            component: RepaymentWithExcessAmount,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'RepaymentWithExcessAmountList',
                                    component: RepaymentWithExcessAmountListView
                                },
                               /* {
                                    path: 'Edit',
                                    name: 'ApplyingRepaymentInAdvanceEdit',
                                    component: ApplyingRepaymentInAdvanceEditView
                                },
                                {
                                    path: 'approve',
                                    name: 'ApplyingRepaymentInAdvanceApprove',
                                    component: ApplyingRepaymentInAdvanceApproveView
                                },
                                {
                                    path: 'view',
                                    name: 'ApplyingRepaymentInAdvanceApproveView',
                                    component: ApplyingRepaymentInAdvanceApproveViewView
                                },*/
                            ]
                        },
                        {
                            path: 'FinanceForExtending',
                            component: ()=>import('../views/fang/FinanceForExtendingView'),
                            children: [
                                {
                                    path: '',
                                    redirect: 'List'
                                },
                                {
                                    path: 'List',
                                    name: 'FinancingForExtendingList',
                                    component: ()=>import('../views/fang/FinancingForExtendingList')
                                },
                                {
                                    path: 'Extend',
                                    name: 'FinancingForExtending',
                                    component: ()=>import('../views/fang/FinancingForExtending')
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'FangHisWarrant',
                    name: 'FangHisWarrantView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'HisWarrant',
                            component: HisWarrantView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'HisWarrantListView',
                                    component: HisWarrantListView
                                },

                            ]
                        },
                        {
                            path:'HisWarrantCheckoutList',
                            component: FangCustomerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'HisWarrantCheckoutListView',
                                    component: HisWarrantCheckoutListView
                                },
                                {
                                    path: 'Create',
                                    name: 'HisWarrantCheckoutView',
                                    component: HisWarrantCheckoutView
                                },

                            ]
                        },


                        {
                            path:'HisWarrantApproveList',
                            component: FangCustomerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'HisWarrantApproveListView',
                                    component: HisWarrantApproveListView
                                },
                                {
                                    path: 'approved',
                                    name: 'HisWarrantApprove',
                                    component: HisWarrantApproveView
                                },
                                {
                                    path: 'view',
                                    name: 'HisWarrantApproveView',
                                    component: HisWarrantApproveViewView
                                },
                                {
                                    path: 'HisWarrantPrint',
                                    name: 'HisWarrantPrintView',
                                    component: HisWarrantPrintView
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'FangProxyPerson',
                    name: 'FangProxyPersonView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'ProxyPerson',
                            component: ProxyPersonView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'ProxyPersonListView',
                                    component: ProxyPersonListView
                                },
                                {
                                    path: 'Add',
                                    name: 'ProxyPersonAddView',
                                    component: ProxyPersonAddView
                                },


                            ]
                        },
                        {
                            path:'HisWarrantCheckoutList',
                            component: FangCustomerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'HisWarrantCheckoutListView',
                                    component: HisWarrantCheckoutListView
                                },
                                {
                                    path: 'Create',
                                    name: 'HisWarrantCheckoutView',
                                    component: HisWarrantCheckoutView
                                },
                            ]
                        },
                        {
                            path:'HisWarrantApproveList',
                            component: FangCustomerView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'HisWarrantApproveListView',
                                    component: HisWarrantApproveListView
                                },
                                {
                                    path: 'approved',
                                    name: 'HisWarrantApprove',
                                    component: HisWarrantApproveView
                                },
                                {
                                    path: 'view',
                                    name: 'HisWarrantApproveView',
                                    component: HisWarrantApproveViewView
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'FangDealerFinancing',
                    name: 'FangDealerFinancingView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'FirstFinancingList',
                            component: FirstFinancing,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'FirstFinancingListView',
                                    component: FirstFinancingListView
                                },

                            ]
                        },
                        {
                            path: 'InfoSupplyList',
                            component: InfoSupply,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'InfoSupplyList',
                                    component: InfoSupplyListView
                                },
                                {
                                    path: 'Add',
                                    name: 'InfoSupplyAdd',
                                    component: InfoSupplyAddView
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'FangPayFinancing',
                    name: 'PayFinancingView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'PaymentList',
                            component: PaymentView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'PayFinancingListView',
                                    component: PayFinancingListView
                                },
                                {
                                    path: 'pay',
                                    name: 'PaymentFinancingView',
                                    component: PaymentFinancingView
                                },
                                {
                                    path: 'TLTone',
                                    name: 'PayFinancingTLT1View',
                                    component: PayFinancingTLT1View
                                },
                                {
                                    path: 'TLTtwo',
                                    name: 'PayFinancingTLT2View',
                                    component: PayFinancingTLT2View
                                },
                                {
                                    path: 'BANKTRANSFER',
                                    name: 'PayFinancingBANKTRANSFERView',
                                    component: PayFinancingBANKTRANSFERView
                                },
                            ]
                        },
                        {
                            path: 'LoanRecordList',
                            component: LoanRecord,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'LoanRecordListView',
                                    component: LoanRecordListView
                                },

                                {
                                    path: 'View',
                                    name: 'LoanRecordView',
                                    component: LoanRecordView
                                },
                            ]
                        },

                        {
                            path: 'RepaymentList',
                            component: RepaymentView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'RepayFinancingListView',
                                    component: RepayFinancingListView
                                },

                                {
                                    path: 'Repay',
                                    name: 'RepayFinancingView',
                                    component: RepayFinancingView
                                },
                            ]
                        },
                        {
                            path: 'FinancingRepaymentList',
                            component: FinancingRepaymentView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'FinancingRepaymentListView',
                                    component: FinancingRepaymentListView
                                },
                            ]
                        },
                        {
                            path: 'InterestConfirmList',
                            component: InterestConfirmView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'InterestConfirmListView',
                                    component: InterestConfirmListView
                                },
                                {
                                    path: 'View',
                                    name: 'InterestConfirmViewView',
                                    component: InterestConfirmViewView
                                },
                            ]
                        },
                        {
                            path: 'InterestReviewList',
                            component: InterestConfirmView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'InterestReviewListView',
                                    component: InterestReviewListView
                                },
                                {
                                    path: 'View',
                                    name: 'InterestConfirmViewView',
                                    component: InterestConfirmViewView
                                },
                            ]
                        },
                        {
                            path: 'ImportBankTally',
                            component: ImportBankTally,
                            children: [
                                {
                                    path: '',
                                    redirect: 'Add',
                                },
                                {
                                    path: 'Add',
                                    name: 'ImportBankTallyView',
                                    component: ImportBankTallyView
                                },
                            ]
                        },
                        {
                            path: 'ImportBankTallyLogList',
                            component: ImportBankTallyLog,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'ImportBankTallyLogList',
                                    component: ImportBankTallyLogListView
                                },
                            ]
                        },
                        {
                            path: 'DepositApplicationForApprovalList',
                            component: DepositApplicationForApprovalView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'DepositApplicationForApprovalListView',
                                    component: DepositApplicationForApprovalListView
                                },
                                {
                                    path: 'addDA',
                                    name: 'DepositApplicationDAView',
                                    component: DepositApplicationDAView
                                },
                                {
                                    path: 'addDR',
                                    name: 'DepositApplicationDRView',
                                    component: DepositApplicationDRView
                                },
                                {
                                    path: 'approve',
                                    name: 'ApproveDepositApplication',
                                    component: ApproveDepositApplication
                                },
                            ]
                        },
                        {
                            path: 'DepositBalanceList',
                            component: DepositBalanceView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'DepositBalanceListView',
                                    component: DepositBalanceListView
                                },
                                {
                                    path: 'DepositTxList',
                                    name: 'DepositTxListView',
                                    component: DepositTxListView
                                },
                                {
                                    path: 'FinancingWithDepositList',
                                    name: 'FinancingWithDepositListView',
                                    component: FinancingWithDepositListView
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'FangReporting',
                    name: 'FangReportingView',
                    component: {
                        template: '<router-view />'
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'FangOverdueList',
                            name:'FangReportingOverdueListView',
                            component: FangReportingOverdueListView
                        },
                        {
                            path: 'FangReportingFinanceList',
                            component: FangReportingFinanceListView

                        },
                        {
                            path: 'FangFinanceAmountByDayList',
                            component: FangFinanceAmountByDayListView

                        },
                        {
                            path: 'FangFinanceAmountByDayList',
                            component: FangFinanceAmountByDayListView

                        },
                        {
                            path: 'FangFinanceAmountByMonthList',
                            component: FangFinanceAmountByMonthListView

                        },
                        {
                            path: 'OutstandingMonthlyList',
                            component: OutstandingMonthlyListView

                        },
                        {
                            path: 'OutstandingDaily',
                            component: OutstandingDailyView

                        },

                        {
                            path: 'OutstandingDetail',
                            component: OutstandingDetailView

                        },

                        {
                            path: 'OutstandingDetail',
                            component: OutstandingDetailView

                        },
                        {
                            path: 'FinancingPaymentList',
                            component: FinancingPaymentListView

                        },
                        {
                            path: 'FangFinanceAmountDetailList',
                            component: FangFinanceAmountDetailListView

                        },
                        {
                            path: 'RepayReportByMonthList',
                            component: RepayReportByMonthListView
                        },
                        {
                            path: 'BankStatementSummaryList',
                            component: BankStatementSummary,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'BankStatementSummaryList',
                                    component: BankStatementSummaryListView
                                },
                                {
                                    path: 'View',
                                    name: 'BankStatementUseList',
                                    component: BankStatementUseListView
                                },
                            ]
                        },
                        {
                            path: 'RepaymentExcessAmountList',
                            component: RepaymentExcessAmountListView
                        },
                        {
                            path: 'OutstandingToDateOldList',
                            component: OutstandingToDateOldListView

                        },
                        {
                            path: 'InterestRevenueList',
                            component: InterestRevenueListView

                        },
                    ]
                },
                {
                    path: 'FangLenderReporting',
                    name: 'FangLenderReportingView',
                    component: {
                        template: '<router-view />'
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },

                        {
                            path: 'OutstandingMonthly2021List',
                            component: OutstandingMonthly2021ListView

                        },

                        {
                            path: 'OutstandingDaily2021',
                            component: OutstandingDaily2021View

                        },

                        {
                            path: 'OutstandingDetail2021',
                            component: OutstandingDetail2021View

                        },

                        {
                            path: 'ThreeTierRebateList',
                            component: ThreeTierRebateListView
                        },
                        {
                            path: 'FinancingList',
                            component: FinancingReportListView
                        },
                        {
                            path: 'RepaymentPlanList',
                            component: RepaymentPlanListView
                        },
                        {
                            path: 'LenderRebateList',
                            component: LenderRebateListView
                        },
                        {
                            path: 'DealerRebateList',
                            component: DealerRebateListView
                        },

                    ]
                },
                {
                    path: 'FangBranchOffice',
                    name: 'FangBranchOfficeView',
                    component: {
                        template: "<router-view />"
                    },
                    children: [
                        {
                            path: '',
                            component: SubmenuPage
                        },
                        {
                            path: 'BranchOfficeList',
                            component: BranchOfficeView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'BranchOfficeListView',
                                    component: BranchOfficeListView
                                },
                                {
                                    path: 'add',
                                    name: 'BranchOfficeAddView',
                                    component: BranchOfficeAddView
                                },
                                {
                                    path: 'edit',
                                    name: 'BranchOfficeAddView',
                                    component: BranchOfficeAddView
                                },
                            ],
                        },
                        {
                            path: 'BranchUserList',
                            name: 'BranchUserView',
                            component: BranchUserView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'BranchUserListView',
                                    component: BranchUserListView
                                },
                                {
                                    path: 'add',
                                    name: 'BranchUserAddView',
                                    component: BranchUserAddView
                                },
                                {
                                    path: 'edit',
                                    name: 'BranchUserAddView',
                                    component: BranchUserAddView
                                },
                            ],
                        },
                        {
                            path: 'BranchAllocationList',
                            name: 'BranchAllocationView',
                            component: BranchAllocationView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'BranchAllocationListView',
                                    component: BranchAllocationListView
                                },
                            ],
                        },
                        {
                            path: 'BranchAppointmentList',
                            name: 'BranchAppointmentView',
                            component: BranchAppointmentView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'BranchAppointmentListView',
                                    component: BranchAppointmentListView
                                },
                                {
                                    path: 'approve',
                                    name: 'ApproveBranchAppointmentView',
                                    component: ApproveBranchAppointmentView
                                },
                            ],
                        },
                        {
                            path: 'BranchAppointmentViewList',
                            name: 'BranchAppointmentViewList',
                            component: BranchAppointmentView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'BranchAppointmentViewListView',
                                    component: BranchAppointmentViewListView
                                },
                                {
                                    path: 'view',
                                    name: 'BranchAppointmentView',
                                    component: BranchAppointmentViewView
                                },
                                {
                                    path: 'signing',
                                    name: 'signingView',
                                    component: signingView
                                },
                            ],
                        },

                        {
                            path: 'BranchAssignmentList',
                            name: 'BranchAssignmentView',
                            component: BranchAssignmentView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'BranchAssignmentListView',
                                    component: BranchAssignmentListView
                                },
                                {
                                    path: 'add',
                                    name: 'BranchAssignmentAddView',
                                    component: BranchAssignmentAddView
                                },
                                {
                                    path: 'edit',
                                    name: 'BranchAssignmentAddView',
                                    component: BranchAssignmentAddView
                                },
                                {
                                    path: 'view',
                                    name: 'BranchAssignmentViewView',
                                    component: BranchAssignmentViewView
                                },
                            ],
                        },
                        {
                            path: 'BranchNoticeList',
                            name: 'BranchNoticeListView',
                            component: BranchNoticeView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'BranchNoticeListView',
                                    component: BranchNoticeListView
                                },
                                {
                                    path: 'add',
                                    name: 'BranchNoticeAddView',
                                    component: BranchNoticeAddView
                                },
                                {
                                    path: 'edit',
                                    name: 'BranchNoticeEditView',
                                    component: BranchNoticeAddView
                                },
                                /*{
                                    path: 'view',
                                    name: 'BranchAssignmentViewView',
                                    component: BranchAssignmentViewView
                                },*/
                            ],
                        },
                        {
                            path: 'BranchMessageList',
                            name: 'BranchMessageListView',
                            component: BranchMessageView,
                            children: [
                                {
                                    path: '',
                                    redirect: 'List',
                                },
                                {
                                    path: 'List',
                                    name: 'BranchMessageListView',
                                    component: BranchMessageListView
                                },
                                {
                                    path: 'add',
                                    name: 'BranchMessageAddView',
                                    component: BranchMessageAddView
                                },
                                {
                                    path: 'edit',
                                    name: 'BranchMessageEditView',
                                    component: BranchMessageAddView
                                },
                                {
                                    path: 'view',
                                    name: 'BranchMessageViewView',
                                    component: BranchMessageViewView
                                },
                            ],
                        },
                    ]
                },
            ]
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js